// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__YBM3C","inner":"Footer_inner__3TXxy","nextIcon":"Footer_nextIcon__2yCqi","innerLeft":"Footer_innerLeft__ieN6j"};